module.exports = __webpack_public_path__ + "img/b4.31569f85.jpg";